/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from 'sarsaparilla';

const propTypes = {
    question: PropTypes.object,
    answer: PropTypes.object,
    onSelect: PropTypes.func,
    focusRef: PropTypes.string,
};

const defaultProps = {};

export default class SingleChoiceRadioQuestion extends React.Component {
    onChange(choice) {
        this.props.onSelect(choice);
    }

    render() {
        return (
            <div className="rec-questionnaire-question">
                <fieldset>
                    <legend>
                        <Heading appearance="h3" headingLevel={1}>
                            {this.props.question.description}
                        </Heading>
                    </legend>
                    {this.props.question.choices.map((choice, index) => {
                        const checked =
                            this.props.answer && this.props.answer.value === choice.value;
                        return (
                            <div
                                key={`${this.props.question.id}_choice_${index}`}
                                className="rec-form-check-wrap"
                            >
                                <label
                                    htmlFor={`radio-${index}`}
                                    className="rec-label-radio"
                                >
                                    <input
                                        type="radio"
                                        className="rec-input-hide"
                                        id={`radio-${index}`}
                                        name="question-choice"
                                        checked={checked}
                                        value={choice.value}
                                        onChange={this.onChange.bind(this, choice)}
                                        ref={this.props.focusRef}
                                    />
                                    <span className="rec-input-radio" />
                                    {choice.description}
                                </label>
                            </div>
                        );
                    })}
                </fieldset>
            </div>
        );
    }
}

SingleChoiceRadioQuestion.displayName = 'SingleChoiceRadioQuestion';
SingleChoiceRadioQuestion.propTypes = propTypes;
SingleChoiceRadioQuestion.defaultProps = defaultProps;
